export default __webpack_public_path__ + "static/N0166-57be016f74cf410bdea3fe5179b201b4.png";